import api from '@/api';
import moment from 'moment';

const state = {
  projectName: '',
};

const actions = {
  async exportWorkItemsToWord({ state, commit }, payload) {
    commit('projectName', payload);
    const response = await api.post('Reports/ExportWorkItemsToWord', {
      projectName: payload,
    }, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `WorkItems_${state.projectName}_${moment().format('YYYY-MM-DD')}.docx`);
    document.body.appendChild(link);
    link.click();
  },
};

const mutations = {
  projectName(state, payload) {
    state.projectName = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
